import React from 'react';

import { AnchorBlockData } from 'api/cms';
import { Box } from 'components/Box';

type Props = {
  data: AnchorBlockData;
};

export function AnchorBlock({ data: { anchor } }: Props) {
  return (
    <Box component="a" data-qa-id={`anchor-block-${anchor}`} id={anchor} />
  );
}
